import type { PaymentType } from '@lt/api/dist/types/payment';
import {
  SbpLogo,
  TPayLogo,
  YandexPay,
} from '@lt/components/icons-react/payment';
import { PaymentMir } from '@lt/components/icons-react/userflow';
import React from 'react';
import styles from '../../paymentMethod.module.css';

type BadgeParams = {
  type: PaymentType;
  isMobile: boolean;
};

const PaymentMethodIcon = ({
  type,
  isMobile,
}: BadgeParams): JSX.Element | null => {
  switch (true) {
    case type === 'sbp':
      return <SbpLogo className={styles.sbpLogo} width={isMobile ? 32 : 40} />;
    case type === 't_pay':
      return <TPayLogo className={styles.sbpLogo} width={38} />;
    case type === 'yandex_pay':
      return <YandexPay className={styles.sbpLogo} width={38} />;
    case type.includes('mir_cashback'):
      return <PaymentMir width={34} />;
    default:
      return null;
  }
};

export default PaymentMethodIcon;
